__turbopack_context__.v({
  "cardTitle": "FeaturesSection-module__JWE4ba__cardTitle" + " " + __turbopack_context__.i(515534)["cardTitle"],
  "contentContainer": "FeaturesSection-module__JWE4ba__contentContainer",
  "featureCard": "FeaturesSection-module__JWE4ba__featureCard",
  "featureImage": "FeaturesSection-module__JWE4ba__featureImage",
  "featuresGrid": "FeaturesSection-module__JWE4ba__featuresGrid",
  "heading": "FeaturesSection-module__JWE4ba__heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "section": "FeaturesSection-module__JWE4ba__section",
  "textContainer": "FeaturesSection-module__JWE4ba__textContainer",
});
